import React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { Menu, MenuItem, IconButton } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import {
  IPublishedGraphic,
  IPublishedGraphicBaseLocationAWS,
} from '../../types/publishedGraphic'
import { triggerNotification } from '../../actions/notifications'
import { copyToClipboard } from '../../services/common'
import { getPublicLocation } from '../../services/publishedGraphic'
import { CopyLinkButton, ActionsContainer } from './styled'

interface IPublishedGraphicSidebar {
  publishedGraphic: IPublishedGraphic
  dispatch: Dispatch
}

const PublishedGraphicActionsComponent = ({
  publishedGraphic,
  dispatch,
}: IPublishedGraphicSidebar) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const { title } = publishedGraphic
  const publicLocation = getPublicLocation(publishedGraphic)
  const shortURI =
    publicLocation &&
    (publicLocation as IPublishedGraphicBaseLocationAWS).shortURI

  if (!shortURI) {
    return null
  }

  const handleClick = (e): void => {
    setAnchorEl(e.currentTarget)
  }
  const copy = (url: string): void => {
    copyToClipboard(url, () => {
      dispatch(triggerNotification('Copied'))
    })
  }
  const handleClose = (): void => {
    setAnchorEl(null)
  }

  return (
    <ActionsContainer>
      <CopyLinkButton
        type="button"
        variant="contained"
        color="primary"
        onClick={() => {
          copyToClipboard(shortURI, () => {
            dispatch(triggerNotification('Copied'))
          })
        }}
      >
        Copy link
      </CopyLinkButton>
      <IconButton type="button" onClick={handleClick}>
        <MoreVert color="primary" />
      </IconButton>
      <Menu
        id="editon-copy-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem onClick={() => copy(`${title} ${shortURI}`)}>
          Copy link and title
        </MenuItem>
        <MenuItem>
          <a href={`mailto:?subject=${title}&body=${title} ${shortURI}`}>
            Email link
          </a>
        </MenuItem>
        <MenuItem>
          <a href={shortURI} target="_blank" rel="noopener noreferrer">
            Open in browser
          </a>
        </MenuItem>
      </Menu>
    </ActionsContainer>
  )
}

export const PublishedGraphicActions = connect()(
  PublishedGraphicActionsComponent
)
